/* globals clicky, clicky_custom */
const AnalyticsException = require('./analytics-exception');

class ClickyAnalytics {
  /**
   * Create an instance of the class
   */
  constructor () {
    if (typeof clicky === 'undefined') {
      throw new AnalyticsException(
        'Cannot find Clicky Analytics (clicky) service'
      );
    }
  }

  /**
   * Send a new goal to Google Analytics
   *
   * @param {String} uri
   * @param {String} name The name of the goal
   * @param {String} goal Optional goal id
   * @param {String} email Optional lead email address
   */
  sendGoal (uri, name, goal = null, email = '') {
    // We can only log clicky custom trackers if the clicky_custom variable has
    // been defined prior to the initialization of clicky analytics
    if (typeof clicky_custom !== 'undefined') {
      clicky_custom = {
        href: uri,
        goal: name,
        session: {
          email,
          signup: 1,
          email: email
        },
        visitor: {
          email: email
        }
      };
    }

    if (goal !== null) {
      clicky.goal(goal);
    }

    clicky.log(uri);
  }
}

module.exports = ClickyAnalytics;
